<header [class.scrolled]="isScrolled">

  <div class="header-inner">

    <!-- Logo -->
    <a class="header-logo" href="#apresentation" (click)="scrollTo('#apresentation', $event)">
      <img
        src="assets/images/logo-breakers.png"
        alt="Breakers – A Queda das Chamas"
        class="logo-img"
      >
    </a>

    <!-- Navegação -->
    <nav class="header-nav" [class.open]="menuOpen" aria-label="Navegação principal">
      <ul class="nav-list">
        <li><a href="#apresentation" (click)="scrollTo('#apresentation', $event)">Início</a></li>
        <li><a href="#sinopse"       (click)="scrollTo('#sinopse', $event)">Sinopse</a></li>
        <li><a href="#preview"       (click)="scrollTo('#preview', $event)">Preview</a></li>
        <li><a href="#depoimentos"   (click)="scrollTo('#depoimentos', $event)">Depoimentos</a></li>
        <li><a href="#compra"        (click)="scrollTo('#compra', $event)">Comprar</a></li>
        <li class="nav-fanarts-item">
          <a class="nav-fanarts-link" routerLink="/fanarts" (click)="menuOpen = false">Fanarts</a>
        </li>
      </ul>
    </nav>

    <!-- Ações -->
    <div class="header-actions">
      <a class="header-fanarts" routerLink="/fanarts">Fanarts</a>
      <button
        class="hamburger"
        [class.active]="menuOpen"
        (click)="toggleMenu()"
        aria-label="Abrir ou fechar menu"
        [attr.aria-expanded]="menuOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

  </div>

</header>
